import {Formik, Form, Field, ErrorMessage} from 'formik'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {MessageNotification} from '../../../../Utils/_helpers/ValidationSchema'
import {UpdateOwnersMessageNotificationSetting} from '../Billing/BillingSlice/BillingSlice'

const MessageNotificationModule = ({messageNotification}: any) => {
  const dispatch = useDispatch()
  const messageModuleData = useSelector((state: any) => state?.PurchaseHistory?.messageNotification)
  const [messageModule, setMessageModule] = useState<any>({
    messageRepliesEmail: messageModuleData?.messageRepliesEmail,
    messageRepliesPhone: messageModuleData?.messageRepliesPhone,
    reportEmail: messageModuleData?.reportEmail,
    reportPhone: messageModuleData?.reportPhone,
  })
  useEffect(() => {
    !Array.isArray(messageModuleData) && setMessageModule(messageModuleData)
  }, [
    messageNotification?.messageRepliesEmail,
    messageNotification?.messageRepliesPhone,
    messageNotification?.reportEmail,
    messageNotification?.reportPhone,
  ])
  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_message_notification'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0 fs-2'>Message Notifications</h3>
        </div>
      </div>
      <Formik
        enableReinitialize
        initialValues={messageNotification}
        validationSchema={MessageNotification}
        onSubmit={(val: any) => {
          let finalvalue = {
            messageRepliesEmail: val?.messageRepliesEmail,
            messageRepliesPhone: val?.messageRepliesPhone,
            reportEmail: val?.reportEmail,
            reportPhone: val?.reportPhone,
          }
          dispatch(UpdateOwnersMessageNotificationSetting(finalvalue))
        }}
      >
        {({values, setFieldValue}: any) => (
          <Form>
            <div id='kt_account_message_notification'>
              <div className='card-body border-top p-9'>
                <div className='row align-items-center'>
                  <div className='col-lg-3'>
                    <div className='fs-6 fw-bolder mb-1'>Message Replies (Inbox)</div>
                  </div>
                  <div className='col-lg-4'>
                    <div className='d-flex align-items-center'>
                      <div className='form-check form-check-sm form-check-custom form-check-solid me-10'>
                        <div>
                          <label htmlFor='stagger'>Email</label>
                        </div>
                      </div>
                      <Field
                        data-testid='inputEmailMessageReplies'
                        className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                        placeholder='myemail@mail.com'
                        value={values?.messageRepliesEmail}
                        type='text'
                        onChange={(e: any) => {
                          if (e?.target.value !== '') {
                            setFieldValue('messageRepliesEmail1', true)
                            setFieldValue('messageRepliesEmail', e?.target.value)
                          } else {
                            setFieldValue('messageRepliesEmail1', false)
                            setFieldValue('messageRepliesEmail', '')
                          }
                        }}
                        id='name'
                        name='messageRepliesEmail'
                      />
                      <ErrorMessage
                        className='text-danger'
                        name='messageRepliesEmail'
                        component='span'
                      />
                      {/* <input
                      type='text'
                
                      onChange={(e: any) => {
                        setMessageModule({
                          ...messageModule,
                          messageRepliesEmail: e.target.value,
                        })
                      }}
                      onBlur={() => handleMessageResponce(messageModule)}
                    ></input> */}
                      {/* <span className='text-danger'>
                      {messageNotificationError?.messageRepliesEmail}
                    </span> */}
                    </div>
                  </div>
                  <div className='col-lg-4'>
                    <div className='d-flex align-items-center'>
                      <div className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                        {/* <input
                  className='form-check-input me-5'
                  id='stagger'
                  type='checkbox'
                  data-kt-check='true'
                  // checked={bulkMessageData.staggerMessages}
                /> */}
                        <div>
                          <label htmlFor='stagger'>Phone</label>
                        </div>
                      </div>
                      <Field
                        data-testid='inputPhoneMessageReplies'
                        className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                        placeholder='0423 837 272'
                        value={values?.messageRepliesPhone}
                        onChange={(e: any) => {
                          if (e?.target.value !== '') {
                            setFieldValue('messageRepliesPhone1', true)
                            setFieldValue('messageRepliesPhone', e?.target.value)
                          } else {
                            setFieldValue('messageRepliesPhone1', false)
                            setFieldValue('messageRepliesPhone', '')
                          }
                        }}
                        type='text'
                        id='name'
                        name='messageRepliesPhone'
                      />
                      <ErrorMessage
                        className='text-danger'
                        name='messageRepliesPhone'
                        component='span'
                      />
                      {/* <input
                      type='text'
                   
                      onChange={(e: any) => {
                        setMessageModule({
                          ...messageModule,
                          messageRepliesPhone: e.target.value,
                        })
                      }}
                      onBlur={() => handleMessageResponce(messageModule)}
                    ></input> */}
                      {/* <span className='text-danger'>
                      {messageNotificationError?.messageRepliesPhone}
                    </span> */}
                    </div>
                  </div>
                </div>
                <div className='row mt-3 align-items-center'>
                  <div className='col-lg-3'>
                    <div className='fs-6 fw-bolder mb-1'>Reports:</div>
                  </div>
                  <div className='col-lg-4'>
                    <div className='d-flex align-items-center'>
                      <div className='form-check form-check-sm form-check-custom form-check-solid me-10'>
                        <div>
                          <label htmlFor='stagger'>Email</label>
                        </div>
                      </div>
                      <Field
                        data-testid='inputEmailReports'
                        className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                        placeholder='myemail@mail.com'
                        value={values?.reportEmail}
                        onChange={(e: any) => {
                          if (e?.target.value !== '') {
                            setFieldValue('reportEmail1', true)
                            setFieldValue('reportEmail', e?.target.value)
                          } else {
                            setFieldValue('reportEmail1', false)
                            setFieldValue('reportEmail', '')
                          }
                        }}
                        type='text'
                        id='name'
                        name='reportEmail'
                      />
                      <ErrorMessage className='text-danger' name='reportEmail' component='span' />
                      {/* <input
                      type='text'
                  
                      onChange={(e: any) => {
                        setMessageModule({...messageModule, reportEmail: e.target.value})
                      }}
                      onBlur={() => handleMessageResponce(messageModule)}
                    ></input>
                    <span className='text-danger'>{messageNotificationError?.reportEmail}</span> */}
                    </div>
                  </div>
                  <div className='col-lg-4'>
                    <div className='d-flex align-items-center'>
                      <div className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                        <div>
                          <label htmlFor='stagger'>Phone</label>
                        </div>
                      </div>
                      <Field
                        data-testid='inputPhoneReports'
                        value={values?.reportPhone}
                        onChange={(e: any) => {
                          if (e?.target.value !== '') {
                            setFieldValue('reportPhone1', true)
                            setFieldValue('reportPhone', e?.target.value)
                          } else {
                            setFieldValue('reportPhone1', false)
                            setFieldValue('reportPhone', '')
                          }
                        }}
                        className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                        placeholder='0423 837 272'
                        type='text'
                        id='name'
                        name='reportPhone'
                      />
                      <ErrorMessage className='text-danger' name='reportPhone' component='span' />
                      {/* <input
                      type='text'
                     
                      onChange={(e: any) => {
                        setMessageModule({...messageModule, reportPhone: e.target.value})
                      }}
                      onBlur={() => handleMessageResponce(messageModule)}
                    ></input>
                    <span className='text-danger'>{messageNotificationError?.reportPhone}</span> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                {/* <button className='btn btn-sm gray_bg_purple me-2'>Discard</button> */}
                <button
                  // onClick={handleMessageModule}
                  type='submit'
                  className='btn btn-sm btn-primary'
                  data-testid='btnSaveChangesMessageNotifications'
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default MessageNotificationModule
